














































































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import ApolloClient, { serverBase } from "../apollo";
import gql from "graphql-tag";
import LabelSelector from "../components/LabelSelector.vue";
import InfiniteLoading from "vue-infinite-loading";
import ImageCard from "../components/ImageCard.vue";
import ActorSelector from "../components/ActorSelector.vue";
import IImage from "../types/image";
import ILabel from "../types/label";
import IActor from "../types/actor";
import SceneSelector from "../components/SceneSelector.vue";
import { Touch } from "vuetify/lib/directives";
import hotkeys from "hotkeys-js";

@Component({
  components: {
    LabelSelector,
    InfiniteLoading,
    ImageCard,
    ActorSelector,
    SceneSelector,
  },
  directives: {
    Touch,
  },
})
export default class Lightbox extends Vue {
  @Prop(Array) items!: IImage[];
  @Prop() index!: number | null;

  showImageDetails = true;

  labelSelectorDialog = false;
  allLabels = [] as ILabel[];
  selectedLabels = [] as number[];
  labelEditLoader = false;

  editActorsDialog = false;
  editActors = [] as IActor[];
  editScene = null as { _id: string; name: string } | null;

  removeDialog = false;

  labelSearchQuery = "";

  get sidebarCss() {
    return {
      "overflow-x": "hidden",
      "overflow-y": "scroll",
      height: "100%",
      "z-index": 999,
      width: {
        xs: "100%",
        sm: "100%",
        md: "300px",
        lg: "300px",
        xl: "300px",
        // @ts-ignore
      }[this.$vuetify.breakpoint.name],
    };
  }

  destroyed() {
    hotkeys.unbind("*");
  }

  mounted() {
    hotkeys("*", (ev) => {
      if (this.index === null) return;

      if (ev.keyCode === 27) {
        this.close();
      } else if (ev.keyCode === 37 || ev.keyCode === 65) {
        this.decrementIndex();
      } else if (ev.keyCode === 39 || ev.keyCode === 68) {
        this.incrementIndex();
      } /*else if (ev.keyCode === 70) {
        this.favorite();
      } else if (ev.keyCode === 66) {
        this.bookmark();
      } else if (ev.keyCode >= 48 && ev.keyCode <= 53) {
        const rating = ev.keyCode - 48;
        this.rate(rating);
      } else if (ev.keyCode >= 96 && ev.keyCode <= 101) {
        const rating = ev.keyCode - 96;
        this.rate(rating);
      }*/
    });
  }

  close() {
    this.$emit("index", null);
  }

  decrementIndex() {
    if (this.index === null) return;
    this.$emit("index", Math.max(0, <number>this.index - 1));
  }

  incrementIndex() {
    if (this.index === null) return;
    this.$emit("index", Math.min(<number>this.index + 1, this.items.length - 1));

    // TODO: load next page
    if (this.index == this.items.length - 1) this.$emit("more");
  }

  updateImageLabels(labels: ILabel[]) {
    this.$emit("update", {
      index: this.index,
      key: "labels",
      value: labels,
    });
  }

  editImageScene() {
    if (!this.currentImage) return;

    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!, $opts: ImageUpdateOpts!) {
          updateImages(ids: $ids, opts: $opts) {
            _id
          }
        }
      `,
      variables: {
        ids: [this.currentImage._id],
        opts: {
          scene: this.editScene ? this.editScene._id : null,
        },
      },
    }).then((res) => {
      this.$emit("update", {
        index: this.index,
        key: "scene",
        value: this.editScene,
      });
    });
  }

  editImageActors() {
    if (!this.currentImage) return;

    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!, $opts: ImageUpdateOpts!) {
          updateImages(ids: $ids, opts: $opts) {
            _id
          }
        }
      `,
      variables: {
        ids: [this.currentImage._id],
        opts: {
          actors: this.editActors.map((a) => a._id),
        },
      },
    }).then((res) => {
      this.$emit("update", {
        index: this.index,
        key: "actors",
        value: this.editActors,
      });
      this.editActorsDialog = false;
    });
  }

  openEditActorsDialog() {
    if (!this.currentImage) return;
    this.editActors = JSON.parse(JSON.stringify(this.currentImage.actors));
    this.editActorsDialog = true;
  }

  openRemoveDialog() {
    this.removeDialog = true;
  }

  @Watch("showImageDetails")
  onToggleDetails() {
    this.selectedLabels = [];
  }

  @Watch("index")
  onIndexChange(newVal: number) {
    this.selectedLabels = [];

    if (this.items[newVal]) {
      this.selectedLabels = this.items[newVal].labels.map((l) =>
        this.allLabels.findIndex((k) => k._id == l._id)
      );
      this.editScene = this.items[newVal].scene;
    }
  }

  rate(rating: number) {
    if (!this.currentImage) return;

    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!, $opts: ImageUpdateOpts!) {
          updateImages(ids: $ids, opts: $opts) {
            rating
          }
        }
      `,
      variables: {
        ids: [this.currentImage._id],
        opts: {
          rating,
        },
      },
    }).then((res) => {
      this.$emit("update", {
        index: this.index,
        key: "rating",
        value: rating,
      });
    });
  }

  favorite() {
    if (!this.currentImage) return;

    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!, $opts: ImageUpdateOpts!) {
          updateImages(ids: $ids, opts: $opts) {
            favorite
          }
        }
      `,
      variables: {
        ids: [this.currentImage._id],
        opts: {
          favorite: !this.currentImage.favorite,
        },
      },
    })
      .then((res) => {
        this.$emit("update", {
          index: this.index,
          key: "favorite",
          value: res.data.updateImages[0].favorite,
        });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  bookmark() {
    if (!this.currentImage) return;

    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!, $opts: ImageUpdateOpts!) {
          updateImages(ids: $ids, opts: $opts) {
            bookmark
          }
        }
      `,
      variables: {
        ids: [this.currentImage._id],
        opts: {
          bookmark: this.currentImage.bookmark ? null : Date.now(),
        },
      },
    })
      .then((res) => {
        this.$emit("update", {
          index: this.index,
          key: "bookmark",
          value: res.data.updateImages[0].bookmark,
        });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  editLabels() {
    if (!this.currentImage) return;

    this.labelEditLoader = true;
    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!, $opts: ImageUpdateOpts!) {
          updateImages(ids: $ids, opts: $opts) {
            labels {
              _id
              name
            }
          }
        }
      `,
      variables: {
        ids: [this.currentImage._id],
        opts: {
          labels: this.selectedLabels.map((i) => this.allLabels[i]).map((l) => l._id),
        },
      },
    })
      .then((res) => {
        this.$emit("update", {
          index: this.index,
          key: "labels",
          value: res.data.updateImages[0].labels,
        });
        this.labelSelectorDialog = false;
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        this.labelEditLoader = false;
      });
  }

  openLabelSelector() {
    if (!this.currentImage) return;

    if (!this.allLabels.length) {
      ApolloClient.query({
        query: gql`
          {
            getLabels {
              _id
              name
              aliases
            }
          }
        `,
      })
        .then((res) => {
          if (!this.currentImage) return;

          this.allLabels = res.data.getLabels;
          this.selectedLabels = this.currentImage.labels.map((l) =>
            this.allLabels.findIndex((k) => k._id == l._id)
          );
          this.labelSelectorDialog = true;
        })
        .catch((err) => {
          console.error(err);
        });
    } else {
      this.labelSelectorDialog = true;
    }
  }

  imageLink(image: any) {
    return `${serverBase}/media/image/${image._id}?password=${localStorage.getItem("password")}`;
  }

  get currentImage() {
    if (this.index !== null) return this.items[this.index];
    return null;
  }

  avatar(actor: any) {
    if (actor.avatar)
      return `${serverBase}/media/image/${actor.avatar._id}?password=${localStorage.getItem(
        "password"
      )}`;
    return "";
  }

  avatarColor(actor: any) {
    if (actor.avatar) return actor.avatar.color || "#ffffff";
    return "#ffffff";
  }
}
